module.exports = __webpack_public_path__ + "img/2019-04-08.11f0570a.jpg";